<!--@keyup="$emit('update:data1', $event.target.value)"-->
<template>
    <div id="itemDescription">

        <b-row>
            <b-col xs="12" sm="12" md="12" lg="12" :xl="leftSize">
                <div class="itemMain">
                    <div class="itemSubTitle">{{$t('i_Fournisseur')}}</div>
                    <div class="itemContain">
                        <!--Fournisseur 1-->
                        <b-row align-v="center">
                            <b-col class="aRight" cols="12">
                                <s-comboSelector class="txtPrincipal" showField="supplier" returnField="id" :content="supplierList" name= "cboFourn1" :title="$t('i_Fournisseur1')" :value="_Fourn1" :returnValue.sync="_Fourn1" :selectedItems="_Fourn1"></s-comboSelector>
                            </b-col>
                        </b-row>
                        <!--Code / Coutant 1-->
                        <b-row align-v="center">
                            <b-col class="aRight" cols="6">
                                <s-input id = "codeFourn1" name="codeFourn1" type="text" maxlength="20" :placeholder="$t('i_CodeFounisseur1')" v-model="_CodeFourn1"></s-input>
                            </b-col>
                            <b-col cols="4">
                                <b-row align-v="center">
                                    <s-currencyInput Name="FPrix1" class="Prix" append="$" v-model="_CoutFourn1"></s-currencyInput>
                                </b-row>
                            </b-col>
                        </b-row>

                        <!--Fournisseur 2, 3, 4, 5-->
                        <b-button class="btnMode MargeTop5" type="button" :variant="getTheme.warning" @mousedown="collaps = !collaps"><s-upDownArrow :status="collaps"></s-upDownArrow></b-button>
                        <span v-show="collaps">

                            <!--Fournisseur 2-->
                            <b-row align-v="center">
                                <b-col class="aRight" cols="12">
                                    <s-comboSelector class="txtPrincipal" showField="supplier" returnField="id" :content="supplierList" name= "cboFourn2" :title="$t('i_Fournisseur2')" :value="_Fourn2" :returnValue.sync="_Fourn2" :selectedItems="_Fourn2"></s-comboSelector>
                                </b-col>
                            </b-row>
                            <!--Code / Coutant 2-->
                            <b-row align-v="center">
                                <b-col class="aRight" cols="6">
                                    <s-input id = "codeFourn2" name="codeFourn2" type="text" maxlength="20" :placeholder="$t('i_CodeFounisseur2')" v-model="_CodeFourn2"></s-input>
                                </b-col>
                                <b-col cols="4">
                                    <b-row align-v="center">
                                        <s-currencyInput Name="FPrix2" class="Prix" append="$" v-model="_CoutFourn2"></s-currencyInput>
                                    </b-row>
                                </b-col>
                            </b-row>

                            <div class="splitSpace"/>

                            <!--Fournisseur 3-->
                            <b-row align-v="center">
                                <b-col class="aRight" cols="12">
                                    <s-comboSelector class="txtPrincipal" showField="supplier" returnField="id" :content="supplierList" name= "cboFourn3" :title="$t('i_Fournisseur3')" :value="_Fourn3" :returnValue.sync="_Fourn3" :selectedItems="_Fourn3"></s-comboSelector>
                                </b-col>
                            </b-row>
                            <!--Code / Coutant 3-->
                            <b-row align-v="center">
                                <b-col class="aRight" cols="6">
                                    <s-input id = "codeFourn3" name="codeFourn3" type="text" maxlength="20" :placeholder="$t('i_CodeFounisseur3')" v-model="_CodeFourn3"></s-input>
                                </b-col>
                                <b-col cols="4">
                                    <b-row align-v="center">
                                        <s-currencyInput Name="FPrix3" class="Prix" append="$" v-model="_CoutFourn3"></s-currencyInput>
                                    </b-row>
                                </b-col>
                            </b-row>

                            <div class="splitSpace"/>

                            <!--Fournisseur 4-->
                            <b-row align-v="center">
                                <b-col class="aRight" cols="12">
                                    <s-comboSelector class="txtPrincipal" showField="supplier" returnField="id" :content="supplierList" name= "cboFourn4" :title="$t('i_Fournisseur4')" :value="_Fourn4" :returnValue.sync="_Fourn4" :selectedItems="_Fourn4"></s-comboSelector>
                                </b-col>
                            </b-row>
                            <!--Code / Coutant 4-->
                            <b-row align-v="center">
                                <b-col class="aRight" cols="6">
                                    <s-input id = "codeFourn4" name="codeFourn4" type="text" maxlength="20" :placeholder="$t('i_CodeFounisseur4')" v-model="_CodeFourn4"></s-input>
                                </b-col>
                                <b-col cols="4">
                                    <b-row align-v="center">
                                        <s-currencyInput Name="FPrix4" class="Prix" append="$" v-model="_CoutFourn4"></s-currencyInput>
                                    </b-row>
                                </b-col>
                            </b-row>

                            <div class="splitSpace"/>

                            <!--Fournisseur 5-->
                            <b-row align-v="center">
                                <b-col class="aRight" cols="12">
                                    <s-comboSelector class="txtPrincipal" showField="supplier" returnField="id" :content="supplierList" name= "cboFourn5" :title="$t('i_Fournisseur5')" :value="_Fourn5" :returnValue.sync="_Fourn5" :selectedItems="_Fourn5"></s-comboSelector>
                                </b-col>
                            </b-row>
                            <!--Code / Coutant 5-->
                            <b-row align-v="center">
                                <b-col class="aRight" cols="6">
                                    <s-input id = "codeFourn5" name="codeFourn5" type="text" maxlength="20" :placeholder="$t('i_CodeFounisseur5')" v-model="_CodeFourn5"></s-input>
                                </b-col>
                                <b-col cols="4">
                                    <b-row align-v="center">
                                        <s-currencyInput Name="FPrix5" class="Prix" append="$" v-model="_CoutFourn5"></s-currencyInput>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </span>
                    </div>
                </div>
            </b-col>
        </b-row>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '@/store'

export default{
    name: 'itemFournisseur',
    components: {

    },
    props: ['Fourn1', 'CoutFourn1', 'CodeFourn1', 
            'Fourn2', 'CoutFourn2', 'CodeFourn2', 
            'Fourn3', 'CoutFourn3', 'CodeFourn3', 
            'Fourn4', 'CoutFourn4', 'CodeFourn4', 
            'Fourn5', 'CoutFourn5', 'CodeFourn5',
            'leftSize'],
    data() {
        return {
            collaps: false,
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme']),
        _Fourn1: {
            get: function() {return this.Fourn1},
            set: function(modifiedValue){this.$emit('update:Fourn1', modifiedValue)}
        },
        _Fourn2: {
            get: function() {return this.Fourn2},
            set: function(modifiedValue){this.$emit('update:Fourn2', modifiedValue)}
        },
        _Fourn3: {
            get: function() {return this.Fourn3},
            set: function(modifiedValue){this.$emit('update:Fourn3', modifiedValue)}
        },
        _Fourn4: {
            get: function() {return this.Fourn4},
            set: function(modifiedValue){this.$emit('update:Fourn4', modifiedValue)}
        },
        _Fourn5: {
            get: function() {return this.Fourn5},
            set: function(modifiedValue){this.$emit('update:Fourn5', modifiedValue)}
        },
        _CoutFourn1: {
            get: function() {return this.CoutFourn1},
            set: function(modifiedValue){this.$emit('update:CoutFourn1', modifiedValue)}
        },
        _CoutFourn2: {
            get: function() {return this.CoutFourn2},
            set: function(modifiedValue){this.$emit('update:CoutFourn2', modifiedValue)}
        },
        _CoutFourn3: {
            get: function() {return this.CoutFourn3},
            set: function(modifiedValue){this.$emit('update:CoutFourn3', modifiedValue)}
        },
        _CoutFourn4: {
            get: function() {return this.CoutFourn4},
            set: function(modifiedValue){this.$emit('update:CoutFourn4', modifiedValue)}
        },
        _CoutFourn5: {
            get: function() {return this.CoutFourn5},
            set: function(modifiedValue){this.$emit('update:CoutFourn5', modifiedValue)}
        },
        _CodeFourn1: {
            get: function() {return this.CodeFourn1},
            set: function(modifiedValue){this.$emit('update:CodeFourn1', modifiedValue)}
        },
        _CodeFourn2: {
            get: function() {return this.CodeFourn2},
            set: function(modifiedValue){this.$emit('update:CodeFourn2', modifiedValue)}
        },
        _CodeFourn3: {
            get: function() {return this.CodeFourn3},
            set: function(modifiedValue){this.$emit('update:CodeFourn3', modifiedValue)}
        },
        _CodeFourn4: {
            get: function() {return this.CodeFourn4},
            set: function(modifiedValue){this.$emit('update:CodeFourn4', modifiedValue)}
        },
        _CodeFourn5: {
            get: function() {return this.CodeFourn5},
            set: function(modifiedValue){this.$emit('update:CodeFourn5', modifiedValue)}
        },
        supplierList : () => store.getters.getSuppliersOnClient?.data?.supplierList,
    }
}
</script>

<style lang="scss" scoped>

</style>